export const GET_BUILDING = 'GET_BUILDING'
export const HANDLE_GET_BUILDING = 'HANDLE_GET_BUILDING'

export const GET_BUILDING_RESOURCE = 'GET_BUILDING_RESOURCE'
export const HANDLE_GET_BUILDING_RESOURCE = 'HANDLE_GET_BUILDING_RESOURCE'
